module.exports = __webpack_public_path__ + "img/round1.8b7103f9.svg";